// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.virtual-table .cell-wrapper.connected,
.virtual-table .cell-wrapper.connected span,
.virtual-table .cell-wrapper.connected strong {
  color: green;
}

.virtual-table .cell-wrapper.connecting,
.virtual-table .cell-wrapper.connecting span,
.virtual-table .cell-wrapper.connecting strong {
  color: orange;
}

.virtual-table .cell-wrapper.disconnected,
.virtual-table .cell-wrapper.disconnected span,
.virtual-table .cell-wrapper.disconnected strong {
  color: dimslategray;
}
`, "",{"version":3,"sources":["webpack://./src/routes/FavoriteHubs/style.css"],"names":[],"mappings":"AAAA;;;EAGE,YAAY;AACd;;AAEA;;;EAGE,aAAa;AACf;;AAEA;;;EAGE,mBAAmB;AACrB","sourcesContent":[".virtual-table .cell-wrapper.connected,\n.virtual-table .cell-wrapper.connected span,\n.virtual-table .cell-wrapper.connected strong {\n  color: green;\n}\n\n.virtual-table .cell-wrapper.connecting,\n.virtual-table .cell-wrapper.connecting span,\n.virtual-table .cell-wrapper.connecting strong {\n  color: orange;\n}\n\n.virtual-table .cell-wrapper.disconnected,\n.virtual-table .cell-wrapper.disconnected span,\n.virtual-table .cell-wrapper.disconnected strong {\n  color: dimslategray;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
